import styled from 'styled-components';
import { css, breakpoints } from '../../../../styles/theme';
import { WallboxSelectStyled } from '../../WallboxSelectStyled';
import { rem } from 'polished';

export const WallboxSelectOV = styled(WallboxSelectStyled)`
    .titleWrapper {
        .title {
            text-transform: capitalize;
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }
`;
